export default __webpack_public_path__ + "static/media/outgoing-success.74487ffd.svg";